import React from 'react';
import StringSelector from '../Form/StringSelector';
import "react-image-gallery/styles/css/image-gallery.css";
import { endpoints } from '../../utils/Constants';
import { useFetchEntity } from '../../Services/fetchApi';

import { useFormikContext } from 'formik';
import UploadButtonForm from '../Form/UploadButtonForm';

const ImageForm = ({ fileId, contentFieldId, ...rest }) => {
    const fileField = fileId ? fileId : "file";
    const contentField = contentFieldId ? contentFieldId : 'contentType';

    const { values } = useFormikContext();
    const fileValue = values[fileField];
    const contentValue = values[contentField];
    const data = [contentValue, fileValue].join(",");
    return fileValue && contentField ? <img alt={'Aircraft'}{...rest} src={data} style={{ width: '100%' }} /> : <h1>No Image</h1>;
}

const AircraftImageDetail = () => {
    const [settings] = useFetchEntity({ name: 'SupplierOptions', getByStatus: () => endpoints.getSupplierOptions });

    return <React.Fragment>
        <ImageForm />
        <StringSelector id='category' label="Category" options={settings ? settings.contentCategory : []} />
        <UploadButtonForm accept="image/x-png,image/gif,image/jpeg"/>
    </React.Fragment>
}

export default AircraftImageDetail;